import { createContext } from "react";
import type { TreeStructureContextType } from "./types";

const TreeStructureContext = createContext<TreeStructureContextType>(
	null as never,
);

export default TreeStructureContext;
